import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Select, message } from "antd";
import TableCom from "@src/components/TableCom";
import BreadCrumbBar from "@src/components/BreadCrumbBar";
import SearchForm from "@src/components/FormItem";
import { useNavigate } from "react-router-dom";
import {
  levelOptions,
  sourceOptions,
  statusOptions,
  customerStatusList,
} from "../config";
import {
  getAllUsers,
  getEntryList,
  editBusinessUser,
  getBusinessAndTax,
  getUsersGroup,
  getUserInfo,
} from "../promises";
import "../index.scss";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
const { Option } = Select;
const breads = [
  {
    label: "交易实体",
    path: "",
  },
  {
    label: "企业实体",
    path: "",
  },
];
let timeout: any = null;
const searchUsers = (value?: any, callback?: any) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  const fake = () => {
    const params = {
      size: 100,
      current: 1,
      keywords: value,
    };
    getAllUsers(params).then((res: any) => {
      if (res?.code === 200) {
        callback(res?.data?.records);
      }
    });
  };
  if (value) {
    timeout = setTimeout(fake, 300);
  } else {
    callback([]);
  }
};
const Enterprise = () => {
  const navigate = useNavigate();
  const [pageOptions, setPageOptions] = useState({
    pageSize: 20,
    current: 1,
  });
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState<any>({});
  const [users, setUsers] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [allUsers, setAllUsers] = useState<any>([]);
  const [business, setBusiness] = useState<any>([]);
  const [grops, setGrops] = useState([]);
  useEffect(() => {
    getUserList();
    getList();
    getBusinessList();
    getGrops();
  }, []);
  // 获取用户组
  const getGrops = async () => {
    const res = await getUsersGroup({
      current: 1,
      size: 10000,
    });
    if (res?.code === 200) {
      const list = res?.data?.records.filter(
        (item: any) => item.name === "业务员"
      );
      if (list && list.length !== 0) {
        const response = await getUserInfo(list[0]?.id);
        if (response?.code === 200) {
          setGrops(response?.data?.members);
        }
      }
    }
  };
  const getUserList = async () => {
    const res: any = await getAllUsers({
      current: 1,
      size: 1000,
    });
    if (res?.code === 200) {
      setAllUsers(res?.data?.records);
    }
  };
  const handleOk = async (params: any) => {
    const res: any = await editBusinessUser(params);
    if (res?.code === 200) {
      setOpen(false);
      getList();
    }
  };
  // 列表数据
  const getList = async (object?: any) => {
    const params = {
      type: "ENTERPRISE",
      current: pageOptions.current,
      size: pageOptions.pageSize,
      // ...search,
      ...object,
    };
    setLoading(true);
    if (object?.size && object?.current) {
      setPageOptions({
        current: object?.current,
        pageSize: object?.size,
      });
    }
    try {
      const res = await getEntryList(params);
      if (res?.code === 200) {
        setList(res?.data?.records);
        setTotal(res?.data?.total);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }

    // 数据请求
  };
  let listTimer = useRef<any>(null);
  const onSearch = (values: any) => {
    console.log(values, ";cvvvvvvvv");
    let params: any = {};
    const keys = Object.keys(values);
    keys.forEach((item: string) => {
      if (values[item] !== null) {
        params[item] = values[item];
      }
    });
    const startTime = values.time
      ? dayjs(values.time[0]).format("YYYY-MM-DD") + " 00:00:00"
      : "";
    const endTime = values.time
      ? dayjs(values.time[1]).format("YYYY-MM-DD") + " 23:59:59"
      : "";
    if (values.time && values.time.length !== 0) {
      params.startTime = startTime;
      params.endTime = endTime;
    }
    params = {
      ...params,
      size: pageOptions.pageSize,
      current: pageOptions.current,
    };
    setSearch(params);
    delete params.time;
    if (listTimer.current) {
      clearTimeout(listTimer.current);
      listTimer.current = null;
    }
    listTimer.current = setTimeout(() => {
      getList(params);
    }, 700);
  };

  const handlekeyWords = (values: any) => {
    const val = values.target.value;
    if (listTimer.current) {
      clearTimeout(listTimer.current);
      listTimer.current = null;
    }
    listTimer.current = setTimeout(() => {
      getList({
        keyword: val,
      });
    }, 700);
  };
  // const handleSearch = (values: any) => {
  //     searchUsers(values, (values: any) => {
  //         setUsers(values);
  //     });
  // };
  // 获取搜索业务负责人
  const getBusinessList = async () => {
    const res: any = await getBusinessAndTax("businessLeader");
    if (res?.code === 200) {
      setBusiness(res?.data);
    }
  };

  const rowSelection = {
    onChange: (newSelectedRowKeys: React.Key[], selectedRows: []) => {
      console.log(
        `selectedRowKeys: ${newSelectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
      setSelectedRowKeys(newSelectedRowKeys);
    },
    getCheckboxProps: (record: any) => ({
      disabled: false, // Column configuration not to be checked
      name: record.name,
    }),
  };
  const handlePage = (params: any) => {
    getList({
      ...search,
      current: params.current,
      size: params.pageSize,
    });
  };
  // 导出
  const handleExport = () => {
    const workbook = XLSX.utils.book_new();
    const lists: any = [];
    const fields = {};
    columns.map((item: any) => {
      if (item.dataIndex) {
        lists.push({
          label: item.title,
          value: item.dataIndex,
        });
        fields[item.dataIndex] = item.title;
      }
    });
    const header = lists.map((item: any) => item.value);
    const ws = XLSX.utils.json_to_sheet(
      [
        fields,
        ...list.map((item: any) => {
          let data = {};
          header.forEach((it: any) => {
            data[it] = item[it];
          });
          return data;
        }),
      ],
      {
        header,
        skipHeader: true,
      }
    );
    XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");
    XLSX.writeFile(
      workbook,
      `企业实体_${dayjs(new Date()).format("YYYY-MM-DD")}.xlsx`,
      {
        bookType: "xlsx",
      }
    );
  };
  const formColumns = [
    {
      label: "交易级别",
      dataIndex: "level",
      type: "Select",
      params: {
        placeholder: "请选择",
        options: levelOptions,
        defaultValue: null,
      },
    },
    {
      label: "来源类型",
      dataIndex: "sourceType",
      type: "Select",
      params: {
        placeholder: "请选择",
        options: sourceOptions,
        defaultValue: null,
      },
    },
    {
      label: "实体状态",
      dataIndex: "status",
      type: "Select",
      params: {
        placeholder: "请选择",
        options: statusOptions,
        defaultValue: null,
      },
    },
    {
      label: "业务负责人",
      dataIndex: "businessLeaderId",
      type: "Select",
      params: {
        placeholder: "请选择",
        defaultValue: null,
        showSearch: true,
        // notFoundContent: null,
        filterOption: (input: string, option: any) => {
          return option?.label !== undefined
            ? option?.label.includes(input)
            : false;
        },
        options: (
          [{ id: null, name: "全部" }, ...business] || [
            { id: null, name: "全部" },
          ]
        ).map((item: any) => ({
          value: item?.id,
          label: item?.name,
        })),
      },
    },
    {
      label: "创建日期",
      dataIndex: "time",
      type: "DatePickers",
      params: {},
    },
    {
      label: "搜索",
      dataIndex: "keyword",
      type: "Input",
      params: {
        placeholder: "关键词搜索",

        onChange: handlekeyWords,
      },
    },
  ];
  const columns = [
    {
      title: "id",
      dataIndex: "id",
      render: (record: string) => {
        return (
          <Link to={`/entity/transaction/enterprise/${record}`}>{record}</Link>
        );
      },
    },
    {
      title: "名称",
      dataIndex: "name",
    },
    {
      title: "统一社会信用代码",
      dataIndex: "taxNo",
    },
    {
      title: "业务负责人",
      dataIndex: "businessLeaderName",
    },
    {
      title: "状态",
      dataIndex: "statusName",
      render: (record: any) => {
        const res = customerStatusList.find(
          (item: any) => item.value === record
        );
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                display: "inline-block",
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                backgroundColor: res?.color,
                marginRight: "3px",
              }}
            ></span>
          </div>
        );
      },
    },
    {
      title: "交易级别",
      dataIndex: "levelName",
    },
    {
      title: "来源类型",
      dataIndex: "sourceTypeName",
    },
    {
      title: "来源名称",
      dataIndex: "sourceName",
    },
    {
      title: "创建日期",
      dataIndex: "createDate",
    },
  ];
  return (
    <div className="entirty_list_container">
      <BreadCrumbBar breads={breads}></BreadCrumbBar>{" "}
      <div className="entirty_search_container">
        <SearchForm
          formParams={formColumns}
          onSearch={onSearch}
          optionsList={null}
        ></SearchForm>
      </div>
      <div className="entirty_table_container">
        <div className="entirty_table_nav_flex">
          <div>企业实体列表</div>
          <div>
            <Button
              className="mar_r_8"
              onClick={() => {
                if (selectedRowKeys.length === 0) {
                  message.error("请选择实体数据");
                  return;
                }
                setOpen(true);
                // form.setFieldValue(
                //     "user",
                //     selectedColumns[0]?.businessLeaderId
                // );
              }}
            >
              修改业务负责人
            </Button>
            <Button type="primary" onClick={handleExport}>
              导出
            </Button>
          </div>
        </div>
        <TableCom
          rowKey={(record: any) => record?.id}
          columns={columns}
          dataSource={list}
          pagination={{
            ...pageOptions,
            total,
          }}
          scroll
          params={{
            rowSelection: {
              type: "checked",
              ...rowSelection,
            },
          }}
          onChange={handlePage}
          loading={loading}
        ></TableCom>
      </div>
      {open && (
        <Modal
          open={open}
          title="修改业务负责人"
          onCancel={() => {
            setOpen(false);
            form.resetFields();
          }}
          onOk={() => {
            // handleOk
            form.validateFields().then((res) => {
              const obj = JSON.parse(res?.users || "{}");
              console.log(selectedRowKeys, "ssssssssss");
              // const arr = selectedRowKeys.map((item: any) =>
              //     Number(item)
              // );
              const params = {
                ids: selectedRowKeys,
                userId: Number(obj?.id),
                userName: obj?.name,
              };
              handleOk(params);
              form.resetFields();
            });
          }}
        >
          <Form
            labelCol={{
              span: 5,
            }}
            wrapperCol={{
              span: 18,
            }}
            form={form}
          >
            <Form.Item
              label="业务负责人"
              name="users"
              rules={[{ required: true, message: "请选择业务负责人" }]}
            >
              <Select placeholder="请选择业务负责人">
                {grops.map((item: any) => (
                  <Option key={item.id} value={JSON.stringify(item)}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default Enterprise;
